export default __webpack_public_path__ + "a1759f2fa3dcd3fc676544d3acaf49de.png";